import { baseUrl, UPDATE_MEMBER_VENDOR_LIST_ERROR } from '../../constants';

export const getMemberVendorList = async (id: number) => {
  try {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const response = await fetch(`${baseUrl}/member/vendor?memberid=${id}`, { // TODO not RESTful :(
      headers: new Headers({
        'x-access-token': user.accessToken,
        'Content-Type': 'application/json',
      }),
    });
    if (!response.ok) throw UPDATE_MEMBER_VENDOR_LIST_ERROR;
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    throw UPDATE_MEMBER_VENDOR_LIST_ERROR;
  }
};
